var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFemale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.893,
    height: 34.09,
    viewBox: "0 0 16.893 34.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1055",
    "data-name": "Group 1055",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_107",
    "data-name": "Ellipse 107",
    cx: 2.725,
    cy: 2.725,
    rx: 2.725,
    ry: 2.725,
    transform: "translate(5.722 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_756",
    "data-name": "Path 756",
    d: "M1437.172,526.127l2.657-8.285a2.409,2.409,0,0,1,2.259-1.927h6.948a2.411,2.411,0,0,1,2.26,1.927l2.656,8.285a1.181,1.181,0,1,1-2.249.721l-1.549-4.832-.007,0a.489.489,0,0,0-.922.228.5.5,0,0,0,.006.078h0l.006.018a.435.435,0,0,0,.021.074l1.156,4.077h0l1.569,5.534h0a.788.788,0,0,1,.027.206.772.772,0,0,1-.772.772H1448.9v9.367a1.44,1.44,0,1,1-2.88,0v-9.367h-.925v9.367a1.44,1.44,0,0,1-2.88,0v-9.367h-2.328a.772.772,0,0,1-.772-.772.763.763,0,0,1,.028-.206h0l1.57-5.534h0l1.156-4.077a.448.448,0,0,0,.021-.074l.005-.018h0a.515.515,0,0,0,.006-.078.489.489,0,0,0-.922-.228l-.007,0-1.549,4.832a1.181,1.181,0,0,1-2.249-.721Z",
    transform: "translate(-1437.116 -509.723)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemale);
export default __webpack_public_path__ + "static/media/female.1daaeae414de7db7bfacd63526064c44.svg";
export { ForwardRef as ReactComponent };